<template>
  <!-- Skill Page Area Start !! -->
  <div class="skill">

    <!-- App Title  -->
    <AppTitle></AppTitle>

    <!-- content-title -->
    <div class="content-title">
      <h2>SKILL</h2>
      <img src="../assets/images/logotitle (2).png" alt="타이틀이미지">
    </div>

    <!-- progress Area Start -->
    <div class="contents">
      <!-- Content -->
      <div class="content">
        <!-- Progress1 -->
        <div class="progress">
          <h3>PHOTOSHOP</h3>
          <div class="circle circle1">
            <strong></strong>
          </div>
        </div>

        <!-- Progress2 -->
        <div class="progress">
          <h3>XD</h3>
          <div class="circle circle2">
            <strong></strong>
          </div>
        </div>

        <!-- Progress3 -->
        <div class="progress">
          <h3>HTML5</h3>
          <div class="circle circle3">
            <strong></strong>
          </div>
        </div>

        <!-- Progress4 -->
        <div class="progress">
          <h3>CSS3</h3>
          <div class="circle circle4">
            <strong></strong>
          </div>
        </div>

        <!-- Progress5 -->
        <div class="progress">
          <h3>JAVASCRIPT</h3>
          <div class="circle circle5">
            <strong></strong>
          </div>
        </div>

        <!-- Progress6 -->
        <div class="progress">
          <h3>JQUERY</h3>
          <div class="circle circle6">
            <strong></strong>
          </div>
        </div>
      </div>
    </div><!-- 프로그래스바 End -->

    <!-- What_content Area Start -->
    <div class="What_content">
      <div class="content-title">
        <h2>What I Do</h2>
        <img src="../assets/images/logotitle (2).png" alt="타이틀이미지">
      </div>

      <div class="slider">
        <!-- Slider main container -->
        <div class="swiper">
          <!-- Additional required wrapper -->
          <div class="swiper-wrapper">
            <!-- Slides -->
            <div class="swiper-slide">
              <img src="../assets/images/skill1.png" alt="포토1">
              <h4>APP / Web Design</h4>
              <p>사용자의 요구사항을 기반으로
                편리하고 트랜디한 디자인이 가능합니다</p>
            </div>

            <div class="swiper-slide">
              <img src="../assets/images/skill2.png" alt="포토2">
              <h4>Responsive Web design</h4>
              <p>HTML5,CSS3,Javascript 를 이용하여 반응형 사이트를 제작할 수 있습니다</p>
            </div>

            <div class="swiper-slide">
              <img src="../assets/images/app.png" alt="포토3">
              <h4>Web App</h4>
              <p>Sass,Vue,Javascript 를 이용하여
                앱을 제작할 수 있습니다</p>
            </div>

          </div>

          <div class="swiper-pagination"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppTitle from './component/Header.vue';
export default {
  name: "Skill",
  components: {
    AppTitle
  },
  mounted() {
    this.cc();
    this.swiper();
    this.menuAct3();
  },
  methods: {
    cc() {
      var circle1 = $('.circle1');
      var circle2 = $('.circle2');
      var circle3 = $('.circle3');
      var circle4 = $('.circle4');
      var circle5 = $('.circle5');
      var circle6 = $('.circle6');
      var tl2 = new TimelineMax();

      tl2.from(circle1, 1, { y: 20, opacity: 0 })
        .from(circle2, 1, { y: 20, opacity: 0 })
        .from(circle3, 1, { y: 20, opacity: 0 })
        .from(circle4, 1, { y: 20, opacity: 0 })
        .from(circle5, 1, { y: 20, opacity: 0 })
        .from(circle6, 1, { y: 20, opacity: 0 });

      // :::::::::::::::::::: Circle Area Start 1::::::::::::::::::::
      circle1.circleProgress({
        value: 0.82,
        size: 130, // 캔버스 크기
        startAngle: 4.8, // 시작 각도
        fill: '#548df8',
        thickness: 20, // 두께
        lineCap: "round",
        animation: {
          duration: 1000
        }
      }).on('circle-animation-progress', function (event, progress) {
        $(this).find('strong').html(Math.round(82 * progress) + '<i>%</i>');
      });

      // :::::::::::::::::::: Circle Area Start 2::::::::::::::::::::
      circle2.circleProgress({
        value: 0.92,
        size: 130,
        startAngle: 4.8,
        thickness: 20,
        fill: '#548df8',
        lineCap: "round",
        animation: {
          duration: 2000
        }
      }).on('circle-animation-progress', function (event, progress) {
        $(this).find('strong').html(Math.round(92 * progress) + '<i>%</i>');
      });

      // :::::::::::::::::::: Circle Area Start 3::::::::::::::::::::
      circle3.circleProgress({
        value: 0.91,
        size: 130,
        startAngle: 4.8,
        thickness: 20,
        fill: '#548df8',
        lineCap: "round",
        animation: {
          duration: 4000
        }
      }).on('circle-animation-progress', function (event, progress) {
        $(this).find('strong').html(Math.round(91 * progress) + '<i>%</i>');
      });

      // :::::::::::::::::::: Circle Area Start 4::::::::::::::::::::
      circle4.circleProgress({
        value: 0.82,
        size: 130,
        startAngle: 4.8,
        thickness: 20,
        fill: '#548df8',
        lineCap: "round",
        animation: {
          duration: 5500
        }
      }).on('circle-animation-progress', function (event, progress) {
        $(this).find('strong').html(Math.round(82 * progress) + '<i>%</i>');
      });
      // :::::::::::::::::::: Circle Area Start 5::::::::::::::::::::
      circle5.circleProgress({
        value: 0.72,
        size: 130,
        startAngle: 4.8,
        thickness: 20,
        fill: '#548df8',
        lineCap: "round",
        animation: {
          duration: 7500
        }
      }).on('circle-animation-progress', function (event, progress) {
        $(this).find('strong').html(Math.round(72 * progress) + '<i>%</i>');
      });
      // :::::::::::::::::::: Circle Area Start 6::::::::::::::::::::
      circle6.circleProgress({
        value: 0.63,
        size: 130,
        startAngle: 4.8,
        thickness: 20,
        fill: '#548df8',
        lineCap: "round",
        animation: {
          duration: 8000
        }
      }).on('circle-animation-progress', function (event, progress) {
        $(this).find('strong').html(Math.round(63 * progress) + '<i>%</i>');
      });

    },
    // 스와이퍼 슬라이어
    swiper() {
      const swiper = new Swiper('.swiper', {

        // direction : 'horizontal', 'vertical'
        direction: 'horizontal',       // 슬라이드 방향
        loop: true,             // 슬라이드 루프설정
        slidesPerView: 1,     // 슬라이드 보이기 갯수
        spaceBetween: 20,     // 슬라이드 사이 간격
        autoplay: {
          delay: 2000
        },

        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev',
        // },
        effect: 'slide',
      });
    },
    menuAct3() {
      $('.Skill').removeClass('menu-act');
      $('.Skill').addClass('menu-act');
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../sass/partials/_mixin.scss", "../sass/partials/variable.scss";

.skill {
  .contents {
    .content {
      width: 370px;
      @include ma-ta;
      padding: 0 20px;

      &>div:nth-child(even) {
        float: right;
      }

      &>div:nth-child(odd) {
        float: left;
      }

      &>div {
        position: relative;
        margin-top: 30px;

        h3 {
          @include font-set(bold, 1.7rem, 19px, $my-f2);
          margin-bottom: 17px;
        }

        strong {
          display: inline-block;
          position: absolute;
          right: 43px;
          top: 53px;
          @include font-set(bold, 2rem, 24px, $ff6);
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/skill.vue